import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../../constants';

/**
 * SectionHeader Component
 * Reusable section header component with icon, title, and description
 */
const SectionHeader = ({ icon: Icon, title, description, actionButtons }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        mb: spacing.sm,
        flexDirection: { xs: 'column', sm: 'row' },
        gap: spacing.sm,
        pb: spacing.sm,
        borderBottom: `1px solid ${colors.borderDefault}`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: borderRadius.md,
            background: 'linear-gradient(135deg, #233491, #2f4ac4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 15px rgba(35, 52, 145, 0.35)',
          }}
        >
          {Icon && <Icon sx={{ color: colors.textWhite, fontSize: fonts.fontSizeXl }} />}
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: fonts.weightSemiBold,
              fontSize: fonts.fontSizeLg,
              color: colors.textPrimaryDark,
              mb: description ? spacing.xs : 0,
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              sx={{
                color: colors.textSecondary,
                fontSize: fonts.fontSizeSm,
                fontWeight: fonts.weightNormal,
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      {actionButtons && <Box>{actionButtons}</Box>}
    </Box>
  );
};

export default SectionHeader;
